(function($)
{
    $.extend(true, orion, {
        api: {
            checkout: {}
        }
    });

    /*
	 * var
	 * 	api = orion.api.checkout,
	 * 	uri = "/api-checkout";
	 */
})(jQuery);
